import _useCheckMobileScreen from "./src/useCheckMobileScreen";

export const useCheckMobileScreen = _useCheckMobileScreen;